module.exports = __webpack_public_path__ + "094951541154859cf62779e52653a65d.svg";